import { STATUS } from "Services/Status/Status.types";

export const getRequiredFields = (fields: any) => {
    if (!fields) {

        return [];
    }
    
    return fields.filter((item: any) => item.required && !STATUS.isInactive(item.status));
}

export const filterFieldsByIds = (fields: any, fieldIds: any[]) => {
    if (!fields || !fieldIds) {
        return [];
    }

    return fields.filter((field: any) => fieldIds.includes(field.id));
}

export const convertArrayToObject = (array, key) => array.reduce((acc, curr) => (acc[curr[key]] = curr, acc), {});

export const updateRecord = (props: any, entityName: string) => {
    switch (entityName) {
        case 'vacancy':
            return props?.updateVacancy;
        case 'candidate':
            return props?.updateCandidate;
        case 'business_unit':
            return props?.updateBusinessUnit;
        case 'contact':
            return props?.updateContact;
        default:
            throw new Error("COULD NOT FIND ENTITY");
    }
}